/**
 * True when the current document is running inside a hidden iframe rather than
 * the top window or a popup — the environment MSAL uses for silent token
 * renewal.
 *
 * MSAL points its silent-renewal iframe at the app-origin `redirectUri`, so
 * without a guard the whole SPA boots inside that hidden iframe, fires
 * authenticated API calls that 401, and re-triggers auth — MSAL then throws
 * `block_iframe_reload` and the session cannot recover (#31904). Guarding the
 * app's `bootstrapModule` on this predicate keeps the iframe cheap: MSAL reads
 * the auth response straight from the iframe's URL, no SPA boot required.
 *
 * `opener` is present for popups, which ARE a legitimate interactive surface,
 * so they are excluded. SSR-safe: `win` defaults to `globalThis.window`, which
 * is `undefined` on the server, yielding `false`. The parameter is an
 * injection seam for unit tests.
 */
export function isInMsalSilentIframe(
  win: Pick<Window, 'parent' | 'opener'> | undefined = globalThis.window
): boolean {
  return !!win && win.parent !== win && !win.opener;
}
